import React, {Component} from 'react';
import {Card, Icon, Tooltip} from 'material-ui';
import {withStyles} from 'material-ui/styles/index';
import classNames from 'classnames';
import GoogleMap from 'google-map-react';
import ReactTable from "react-table"; 

const styles = theme => ({
    root: {}
});

function Marker({text})
{

    return (
        <Tooltip title={text} placement="top">
            <Icon className="text-red">place</Icon>
        </Tooltip>
    );
}

class Widget12 extends Component {
    render()
    {
        const {data, classes} = this.props;
        return (
            <Card className={classNames(classes.root, "w-full h-512")}>
                <ReactTable className="w-full"
                    getTrProps={(state, rowInfo, column) => {
                        return {
                            className: "cursor-pointer",
                            onClick: (e, handleOriginal) => {

                            }
                        }
                    }}
                    // data={this.state.data}
                    columns={[

                        {
                            Header: "job id",
                            accessor: "jobId",
                            show: false
                        },

                        {
                            Header: "Job No",
                            accessor: "jobNo",
                            // show: false,
                            filterable: true
                        },
                        {
                            Header: "Customer",
                            accessor: "customer",
                            filterable: true

                        },
                        {
                            Header: "Received Date",
                            accessor: "receivedDate",
                            filterable: true

                        },

                        {
                            Header: "Expected Date",
                            accessor: "expectedDate",
                            filterable: true

                        },

                        {
                            Header: "Complete (%)",
                            accessor: "completePres",
                            filterable: true

                        },

                        {
                            Header: "Priority",
                            accessor: "priority",
                            filterable: true

                        },

                    ]}
                    defaultPageSize={10}
                    className="-striped -highlight"
                />

            </Card>
        );
    }
}

export default withStyles(styles, {withTheme: true})(Widget12);



// WEBPACK FOOTER //
// ./src/main/content/apps/dashboards/widgets/Widget12.js